import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { TLenderId } from '/src/lib/models';
import {
  TDeactivateLenderResponse,
  TGetLenderResponse,
  TListLendersRequest,
  TListLendersResponse,
} from '/src/lib/types';

export class LenderService {
  /**
   * List Lenders
   * @returns Lender[]
   * @throws ApiError
   */
  public static async query(req?: TListLendersRequest): CancelablePromise<TListLendersResponse> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/lenders',
      query: req,
    });
  }

  /**
   * Get Lender
   * @param id TLenderId
   * @returns Lender
   * @throws ApiError
   */
  public static async get(id: TLenderId): CancelablePromise<TGetLenderResponse> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/lenders/{id}',
      path: { id },
    });
  }

  /**
   * Deactivate Lender
   * @param id TLenderId
   * @returns Lender
   * @throws ApiError
   */
  public static async deactivate(id: TLenderId): CancelablePromise<TDeactivateLenderResponse> {
    return await __request(OpenAPI, {
      method: 'DELETE',
      url: '/companies/{id}',
      path: { id },
    });
  }
}
